import { DefineGetters } from "vuex-type-helper";
import { RaterAccountsGetters, RaterAccountsState } from "./types";

export const getters: DefineGetters<
  RaterAccountsGetters,
  RaterAccountsState
> = {
  raterAccountStatus: (state: RaterAccountsState) => state.status,
  raterAccountPool: (state: RaterAccountsState) =>
    state.status ? state.status.pool : null,
  raterAccountQueue: (state: RaterAccountsState) =>
    state.status ? state.status.queue : null,
  raterAccountResetResult: (state: RaterAccountsState) => state.resetResult,
  isPoolExhausted: (state: RaterAccountsState) =>
    state.status ? state.status.pool.available === 0 : false,
  jobLooksWedged: (state: RaterAccountsState) =>
    Boolean(
      state.status && state.status.queue && state.status.queue.looksWedged
    ),
  isLoading: (state: RaterAccountsState) => state.makingApiRequest
};
